import {http} from "../http-common";
import {Product} from "../models/Product";

class ProductDataService {
    async getAll() {
        return await http().get<Array<Product>>("/products");
    }
}
export default new ProductDataService();